import emailjs from "@emailjs/browser";

const templateSendContactToUsID = "template_zxwm9x6";
const templateAutomatedReplyID = "template_p8gr6ib"
const emailServiceID = "service_j3s2y5d";
const emailPublicKey = "-47DGh2xGEPDUJqFs";


const handleEmailFlow = (templateParams, selection = 420) => {
  var sel = typeof selection === "string" ? selection.toLowerCase() : selection;
  // Overwrite or add request_type based on selection
  let paramsWithType = { ...templateParams };
  if (sel === "contactfunnel0" || sel === "default" || sel === 0) {
    paramsWithType.request_type = "/start funnel";
    return sendEmailContactDefault(paramsWithType);
  }
  if (sel === "contactfunnel1" || sel === "trial" || sel === 1) {
    paramsWithType.request_type = "/signup schnupper-funnel";
    return sendEmailContactTrialReply(paramsWithType);
  }
  if (sel === "contact" || sel === 420) {
    paramsWithType.request_type = "/contact";
    return sendEmailContact(paramsWithType);
  }
  // Debug: log if nothing matches
  console.error("No matching selection for sendEmail:", sel);
}
// funnel0 sends to us
const sendEmailContactDefault = (templateParams) => {
  return emailjs
    .send(emailServiceID, templateSendContactToUsID, templateParams, {
      publicKey: emailPublicKey,
    })
    .then((response) => {
      console.log("Email sent successfully!", response.status, response.text);
    })
    .catch((error) => {
      console.error("Failed to send email:", error);
    });
};


const sendEmailContactTrialReply = (templateParams) => {
  // Use the funnel1 template and service
  return emailjs
    .send(emailServiceID, templateAutomatedReplyID, templateParams, {
      publicKey: emailPublicKey,
    })
    .then((response) => {
      console.log("Email sent successfully!", response.status, response.text);
    })
    .catch((error) => {
      console.error("Failed to send email:", error);
    });
};

const sendEmailContact = (templateParams) => {
  return sendEmailContactDefault(templateParams);
}

export default handleEmailFlow;